import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import HomePage from "../pages/home/page";
import FramingPage from "../pages/services/framing/page";
import RoofingPage from "../pages/services/roofing/page";
import SidingPage from "../pages/services/siding/page";
import DeckingPage from "../pages/services/decking/page";
import WindowsDoorsPage from "../pages/services/windows-doors/page";
import GeneralConstructionPage from "../pages/services/general-construction/page";
import RemodelingPage from "../pages/services/remodeling/page";
import NotFoundPage from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/services/framing",
    element: <FramingPage />,
  },
  {
    path: "/services/roofing",
    element: <RoofingPage />,
  },
  {
    path: "/services/siding",
    element: <SidingPage />,
  },
  {
    path: "/services/decking",
    element: <DeckingPage />,
  },
  {
    path: "/services/windows-doors",
    element: <WindowsDoorsPage />,
  },
  {
    path: "/services/general-construction",
    element: <GeneralConstructionPage />,
  },
  {
    path: "/services/remodeling",
    element: <RemodelingPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
